import { useEffect, useMemo, useState } from 'react'
import AttachPracticeToExisting from './AttachPracticeToExisting/AttachPracticeToExisting'
import CreateNewPractice from './CreateNew/CreateNewPractice'
import { AddPracticeComponentContainer, AddPracticeTab, AddPracticeTabs } from './styledComponents'
import { ADD_PRACTICE_TYPES } from './utils'

export default function AddPracticeController({
  myTimers,
  backToPreviousPage,
  clientSessionId,
  clientSessionTime,
  timerTitle,
  timerDuration,
  timerMinDuration,
  timerMaxDuration,
  timerBellType,
  timerPreferredTimes,
  timerType,
  timerId,
}) {
  const [addPracticeType, setAddPracticeType] = useState(ADD_PRACTICE_TYPES.MY_TIMERS)
  const [selectedPractices, setSelectedPractices] = useState([])
  const [title, setTitle] = useState()
  const [duration, setDuration] = useState()
  const [maxDuration, setMaxDuration] = useState()
  const [bellType, setBellType] = useState()
  const [type, setType] = useState()
  const [intervals, setIntervals] = useState([])
  const [reminderTime, setReminderTime] = useState()

  function changeAddPracticeType(e, type) {
    setAddPracticeType(type)
  }

  const AddPracticeComponent = useMemo(() => {
    switch (addPracticeType) {
      case ADD_PRACTICE_TYPES.MY_TIMERS:
        return AttachPracticeToExisting
      case ADD_PRACTICE_TYPES.CREATE_NEW:
        return CreateNewPractice

      default:
        return AttachPracticeToExisting
    }
  }, [addPracticeType])

  useEffect(() => {
    setDuration(timerDuration)
    setMaxDuration(timerMaxDuration)
    setBellType(timerBellType)
    setType(timerType)
    setReminderTime(timerPreferredTimes)
  }, [timerTitle, timerDuration, timerMinDuration, timerMaxDuration, timerBellType, timerType])

  return (
    <AddPracticeComponentContainer>
      <AddPracticeTabs
        value={addPracticeType}
        onChange={changeAddPracticeType}
        aria-label="basic tabs example"
      >
        <AddPracticeTab label="Attach To My Timers" value={ADD_PRACTICE_TYPES.MY_TIMERS} />
        <AddPracticeTab label="Add Timer" value={ADD_PRACTICE_TYPES.CREATE_NEW} />
      </AddPracticeTabs>
      <AddPracticeComponentContainer>
        <AddPracticeComponent
          myTimers={myTimers}
          selectedPractices={selectedPractices}
          setSelectedPractices={setSelectedPractices}
          backToPreviousPage={backToPreviousPage}
          clientSessionId={clientSessionId}
          title={title}
          duration={duration}
          maxDuration={maxDuration}
          bellType={bellType}
          setTitle={setTitle}
          setDuration={setDuration}
          setMaxDuration={setMaxDuration}
          setBellType={setBellType}
          setTimerType={setType}
          timerType={type}
          intervals={intervals}
          setIntervals={setIntervals}
          reminderTime={reminderTime}
          setReminderTime={setReminderTime}
          timerId={timerId}
        />
      </AddPracticeComponentContainer>
    </AddPracticeComponentContainer>
  )
}
